//import logo from './logo.svg';
import LTList from "./LTList";

function App() {
  return (
    <div className="App">
      <LTList/>
   </div>
  );
}

export default App;
